/* unplugin-vue-components disabled */import { render } from "./indexView.vue?vue&type=template&id=2080cd21&scoped=true"
import script from "./indexView.vue?vue&type=script&lang=js"
export * from "./indexView.vue?vue&type=script&lang=js"

import "./indexView.vue?vue&type=style&index=0&id=2080cd21&lang=scss&scoped=true"

import exportComponent from "F:\\hjd\\dev\\yf-dsj\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2080cd21"]])

export default __exports__